import React from "react";
import ShowAllButton from "./ShowAllButton";

const HeaderSection = ({ title, url }) => (
  <div className="flex items-center justify-between mb-1 sm:mb-5">
    <div className="flex items-center">
      <h2 className="text-themeBlack leading-normal sm:text-[28px] text-2xl font-medium">
        {title}
      </h2>
    </div>
    <ShowAllButton title={title} url={url} styles="sm:flex hidden" />
  </div>
);

export default HeaderSection;
